<template>
  <div
    class="vsm-item"
    :class="[
      {'open-item': itemShow},
      {'active-item': active},
      {'parent-active-item': childActive}
    ]"
  >
    <router-link
      class="vsm-link"
      :class="item.class"
      :to="item.href"
      :disabled="item.disabled"
      :event="item.disabled ? '' : 'click'"
      v-bind="item.attributes"
      @click.native="clickEvent"
    >
      <span v-if="item.icon" class="vsm-icon">
        <icool-icon :icon="item.icon" />
      </span>
      <span
        v-if="item.badge"
        :style="[(item.child ? {'margin-right' : '30px'} : '')]"
        class="vsm-badge"
        :class="[item.badge.class ? item.badge.class : 'default-badge']"
        v-bind="item.badge.attributes"
      >{{ item.badge.text }}</span>
      <span class="vsm-title">{{ item.title }}</span>
      <round-icon-button
        icon="angle-right"
        v-if="item.child && enableCollapsing"
        class="vsm-arrow"
        :class="{'open-arrow' : itemShow}"
        @click.stop="expandClickEvent"
      />
    </router-link>
    <template v-if="item.child">
      <transition
        name="expand"
        @enter="expandEnter"
        @afterEnter="expandAfterEnter"
        @beforeLeave="expandBeforeLeave"
      >
        <div
          v-if="itemShow || !enableCollapsing"
          class="vsm-dropdown"
        >
          <div class="vsm-list">
            <item
              v-for="(subItem, index) in item.child"
              :key="index"
              :item="subItem"
            />
          </div>
        </div>
      </transition>
    </template>
  </div>
</template>

<script>
import Item from './Item.vue';
import { itemMixin, animationMixin } from '../mixin';
import RoundIconButton from '@/components/utils/RoundIconButton';

export default {
  components: {
    RoundIconButton,
    Item,
  },
  mixins: [itemMixin, animationMixin],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  beforeCreate() {
    this.$options.components.Item = require('./Item.vue').default;
  },
};
</script>
